import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ac6c941c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=ac6c941c&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6c941c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac6c941c')) {
      api.createRecord('ac6c941c', component.options)
    } else {
      api.reload('ac6c941c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ac6c941c&scoped=true&", function () {
      api.rerender('ac6c941c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/case/withdrawCase/index.vue"
export default component.exports